import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import SuiteFeatureTable from '../feature-table/suite-feature-table/SuiteFeatureTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSuiteFeatureTable = ({
  productsByProductLine,
  screen,
  tab
}) => {
  const [showFeaturesTable, setShowFeaturesTable] = useState(false);
  const handleShowFeaturesTable = evt => {
    evt.preventDefault();
    setShowFeaturesTable(true);
  };
  const handleHideFeaturesTable = evt => {
    evt.preventDefault();
    setShowFeaturesTable(false);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-5 text-center",
    children: [showFeaturesTable ? /*#__PURE__*/_jsx(UIButton, {
      use: "transparent",
      onClick: handleHideFeaturesTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "suiteFeatureTable.mobile.hideAll"
      })
    }) : /*#__PURE__*/_jsx(UIButton, {
      use: "transparent",
      onClick: handleShowFeaturesTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "suiteFeatureTable.mobile.seeAll"
      })
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      style: {
        maxWidth: '100%'
      },
      duration: 500,
      renderContent: () => /*#__PURE__*/_jsx(SuiteFeatureTable, {
        productsByProductLine: productsByProductLine,
        screen: screen,
        tab: tab
      }),
      open: showFeaturesTable
    })]
  });
};
export default MobileSuiteFeatureTable;